// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"09d07157","453":"cafc2bb1"}[chunkId] + ".chunk.js";
};